/* LYVN Diwali - size labels with chest value (S-40) + highlight picked size in Size Chart */
(function () {
  if (window.__lyvnSgRow) return;
  window.__lyvnSgRow = true;

  function norm(v) {
    v = String(v || '').trim().toUpperCase().replace(/\s+/g, '');
    return ({ '2XL': 'XXL', '3XL': 'XXXL' })[v] || v;
  }

  /* chest value (inch) for every size, read from this product's Size Chart table */
  function chestMap() {
    var map = {};
    document.querySelectorAll('.size-guide-table-el tbody tr').forEach(function (tr) {
      var sizeCell = tr.querySelector('td, th');
      var chestCell = tr.querySelector('.sg-col--cm'); /* first value column = chest in inches */
      if (sizeCell && chestCell) {
        var val = chestCell.textContent.trim();
        if (val) map[norm(sizeCell.textContent)] = val;
      }
    });
    return map;
  }

  /* S  ->  S-40 on the size buttons */
  function labelSizes() {
    var map = chestMap();
    if (!Object.keys(map).length) return;
    document.querySelectorAll('fieldset[data-handle="size"] input[type="radio"]').forEach(function (input) {
      var label = document.querySelector('label[for="' + input.id + '"]');
      if (!label) return;
      var span = label.querySelector('span') || label;
      var chest = map[norm(input.value)];
      if (!chest) return;
      var text = input.value + '-' + chest;
      if (span.textContent.trim() !== text) span.textContent = text; /* write only on change */
    });
  }

  function picked() {
    var r = document.querySelector('fieldset[data-handle="size"] input[type="radio"]:checked');
    return r ? norm(r.value) : '';
  }
  function markRow() {
    var size = picked();
    document.querySelectorAll('.size-guide-table-el tbody tr').forEach(function (tr) {
      var cell = tr.querySelector('td, th');
      tr.classList.toggle('sg-row-active', !!size && !!cell && norm(cell.textContent) === size);
    });
  }

  function run() { labelSizes(); markRow(); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sizeguide-modal-open]')) setTimeout(markRow, 0);
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('fieldset[data-handle="size"] input[type="radio"]')) setTimeout(run, 0);
  });

  /* theme re-renders the picker when the variant changes: label again */
  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(labelSizes, 60);
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();